export default {"src":"/_next/static/media/Frame 2147227877 (3).7ffb7d3f.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};